const NoPermissions = () => {
    return ( <>
        <h1>Unauthorized</h1>
        <h5>405</h5>
    </> );
}
 
export default NoPermissions;